import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=05bda80d&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bda80d')) {
      api.createRecord('05bda80d', component.options)
    } else {
      api.reload('05bda80d', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=05bda80d&", function () {
      api.rerender('05bda80d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UxKOg6aFscaW/JS/ImageCarousel.vue"
export default component.exports